export const REF_KEY = 'block';

export enum CatalogPlaces {
  infoContent = 'infoContent',
}

export enum BlockType {
  route = 1,
  block = 2,
}

export enum BlockField {
  editor = 1,
  text = 2,
  reference = 3,
}

export enum BlockTemplate {
  primaryInfoContent = 1,
  reference = 2,
}

export enum BlockDictionary {
  cityName = 'cityName',
  cityNamePrepositional = 'cityNamePrepositional',
  catalogNamePlural = 'catalogNamePlural',
  catalogNamePluralGenitive = 'catalogNamePluralGenitive',
  catalogNamePluralPrepositional = 'catalogNamePluralPrepositional',
  catalogNameSingle = 'catalogNameSingle',
  catalogNameSingleAccusative = 'catalogNameSingleAccusative',
  catalogNameSingleGenitive = 'catalogNameSingleGenitive',
  catalogNameSinglePrepositional = 'catalogNameSinglePrepositional',
  catalogNameSingleInstrumental = 'catalogNameSingleInstrumental',
  catalogNameSingleDative = 'catalogNameSingleDative',
  catalogNameDeclination1 = 'catalogNameDeclination1',
  catalogNameDeclination2 = 'catalogNameDeclination2',
  catalogNameDeclination3 = 'catalogNameDeclination3',
}
